import React from "react"
import './index.css'

function FakeMovieContainer () {
    return (
        <li id="fake-movie-container">
                <div id="fake-movie-poster"/>
                <div id="fake-movie-title"/>
        </li>
    )
}

export { FakeMovieContainer }